import React from "react";

import Buttons from "../../../buttons/buttons";
import authService from "../../../../services/auth.service";

export const MealCard = ({
  showCalorieStatus,
  meal,
  mealIndex,
  activeUserSubscription,
  isExpired,
  openReplaceModal,
  bottomSheetConfig,
  bottomSheetHandler,
  isFasting,
}) => {
  const user = authService.getCurrentUser()?.user;
  const isForeign = user?.is_foreign;
  return (
    <>
      <div className={`meal-col `}>
        <div
          className={`meal md:h-full rounded-xl !p-3 !pb-3 transition ease-in-out delay-150 flex flex-col !shadow-[0px_0px_10px_0px_#F0F0F0] hover:!shadow-[0px_2px_10px_0px_#DEEEEC] border border-white hover:border border-solid 
          ${isFasting ? "hover:border-[#FFA219]" : "hover:border-[#0EAD98]"}
          `}
        >
          <div className="meals-type">
            {meal.featured_image ? (
              <div className="featured-image-container md:!ml-4 mt-[4px] md:!w-[47px] md:!h-[47px]">
                <img src={meal.featured_image} alt="food" />
              </div>
            ) : (
              ""
            )}
            <div>
              <div className="meal-title md:!text-base leading-[22px] mb-[2px] md:mb-[6px]">
                {meal.meal_type ? meal.meal_type : "وعده غذایی"}
              </div>
              <div className="meal-excerpt pl-1">
                بهترین زمان: {meal.meal_type_excerpt}
              </div>
            </div>
            {meal.features.includes("replacement") ? (
              <button
                onClick={(e) => openReplaceModal(meal)}
                className={`btn-replace hover:!opacity-70 ${
                  isFasting ? "!border-[#FFA219] !text-[#FFA219]" : ""
                }`}
                style={{
                  display:
                    activeUserSubscription === null || isExpired
                      ? "none"
                      : "flex",
                }}
              >
                جایگزین
                <svg
                  width="6"
                  height="12"
                  viewBox="0 0 6 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.47803 11.5C5.34536 11.5 5.21269 11.4556 5.10794 11.3604L0.555135 7.22372C-0.185046 6.55119 -0.185046 5.44722 0.555135 4.77469L5.10794 0.637996C5.31045 0.454001 5.64562 0.454001 5.84812 0.637996C6.05063 0.82199 6.05063 1.12653 5.84812 1.31053L1.29532 5.44722C0.96014 5.75177 0.960139 6.24665 1.29532 6.55119L5.84812 10.6879C6.05063 10.8719 6.05063 11.1764 5.84812 11.3604C5.74338 11.4492 5.61071 11.5 5.47803 11.5Z"
                    fill={isFasting ? "#FFA219" : "#0EAD98"}
                  />
                </svg>
              </button>
            ) : (
              ""
            )}
          </div>
          <div className="flex md:flex-1">
            <div className="foods md:!px-3 flex-1 !pt-4 flex flex-col gap-[4px]">
              {meal.foods.map((food) => {
                return (
                  <span className="text-sm text-[#535353] !leading-6 ">
                    {food.summary.split("(")[0]}
                  </span>
                );
              })}
            </div>
            <div className="foods md:!px-3 !pt-4 flex flex-col gap-[4px]">
              {meal.foods.map((food) => {
                const content = food.summary
                  .split("(")
                  [food.summary.split("(").length - 1].slice(0, -1);
                const title = content.split(" ")[0];
                const body = content
                  .split(" ")
                  .filter((item, index) => (index > 0 ? item : null))
                  .join(" ");
                return (
                  <span className="!text-sm !leading-6">
                    <span className={"!text-[#535353] mr-[4px]"}>{title}</span>
                    <span className={"text-[#848484] mr-[4px]"}>{body}</span>
                  </span>
                );
              })}
            </div>
          </div>
          {showCalorieStatus?.calorie_text === 1 && (
            <div className="meal-calorie !leading-[25px] !mt-3 !pt-3 md:!mt-2 md:!pt-2">
              {meal?.calorie_text}
            </div>
          )}
        </div>
      </div>

      {meal.buttons && !isForeign ? (
        <span className={"col-span-1 [&_img]:max-h-[160px] lg:hidden"}>
          <Buttons
            buttons={meal.buttons}
            bottomSheetConfig={bottomSheetConfig}
            bottomSheetHandler={bottomSheetHandler}
          />
        </span>
      ) : (
        ""
      )}
    </>
  );
};
